import React from 'react';
import { ShieldCheckIcon, StarIcon } from 'lucide-react';
import { CHECKOUT_URL, CtaButton } from './CtaButton';
export function FinalCtaSection() {
  return <section className="w-full bg-forest-800 px-6 py-11 sm:py-14" aria-labelledby="final-title" data-id="element-67" data-mp="3lwj52d4qat6k">
      <div className="mx-auto max-w-3xl text-center" data-id="element-68" data-mp="3qrghzv54pmoq">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-ember-400" data-id="element-69" data-mp="3vrkyvm9y8jfh">Last chance</p>
        <h2 id="final-title" className="mt-4 font-display text-3xl font-bold uppercase leading-[1.05] tracking-tight text-cream-50 sm:text-5xl" data-id="element-70" data-mp="2y5x1ay1rbv2d">
          More Order. More Clarity. Better Outcomes.
        </h2>

        <div className="mt-6 rounded-3xl border border-white/15 bg-white/[0.06] p-6 sm:p-8" data-id="element-71" data-mp="380yqtuzy2z5h">
          <p className="text-base text-cream-100/75" data-id="element-72" data-mp="3cvutrq6pz6xd">
            Complete Kit: Surgical Shield System 2026 + 5 Bonuses
          </p>
          <p className="mt-5 flex items-baseline justify-center gap-4" data-id="element-73" data-mp="2kd7fatm8aq59">
            <span className="font-display text-2xl text-cream-100/45 line-through" data-id="element-74" data-mp="2kbctld34uu04">$235 USD</span>
            <span className="font-display text-5xl font-bold text-cream-50 sm:text-6xl" data-id="element-75" data-mp="2de34hjcktg8t">$27 USD</span>
          </p>
          <p className="mx-auto mt-4 max-w-md text-base text-cream-100/85" data-id="element-76" data-mp="23m70xsrq0xx7">
            One-time payment. Instant access. All 6 volumes plus the 5 bonuses at no extra cost.
          </p>
          <CtaButton className="mt-6" variant="light" href={CHECKOUT_URL} label="Start Teaching With Excellence Today" source="final" data-id="element-77" data-mp="1yl9l3mu6ofyv" />
          <div className="mt-6 flex flex-col items-center justify-center gap-3 text-sm text-cream-100/85 sm:flex-row sm:gap-5" data-id="element-78" data-mp="1pos5a6avjtws">
            <span className="flex items-center gap-2" data-id="element-79" data-mp="1forp2t8axtwt">
              <span className="flex" aria-hidden="true" data-id="element-80" data-mp="1fqciugmsl8tm">
                {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-4 w-4 fill-ember-400 text-ember-400" data-id="element-81" data-mp="3eyzsp3kihmd9" />)}
              </span>
              4.9/5 — Faculty rating
            </span>
            <span className="hidden h-4 w-px bg-white/20 sm:block" aria-hidden="true" data-id="element-82" data-mp="18bsett8kmn22" />
            <span className="flex items-center gap-2" data-id="element-83" data-mp="1d5ef0lxjsygz">
              <ShieldCheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-84" data-mp="yfflwxkuod8d" />
              7-day guarantee
            </span>
          </div>
        </div>
      </div>
    </section>;
}